// Feuille « Ajout rapide » du shell mobile Life — DA V3 validée : 6 tuiles
// (Opération, Tâche, Événement, Contact, Document, Objectif) menant vers les
// pages existantes correspondantes.
// Réf. : DEV/mockup_mobile_navigation_v3.html
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

// Chaque raccourci navigue vers la page cible avec ?action=new-… : la page
// ouvre alors directement sa popup de création (même convention que les
// liens SmartFeed /todos?action=new-task) au lieu d'un simple atterrissage.
const ACTIONS = [
  { key: 'operation', label: ['quickAdd.operation', 'Opération'], icon: '💶', color: 'var(--lm-finance)', path: '/gestionoperations?action=new-operation' },
  { key: 'tache', label: ['quickAdd.task', 'Tâche'], icon: '✓', color: 'var(--lm-sante)', path: '/todos?action=new-task' },
  { key: 'evenement', label: ['quickAdd.event', 'Événement'], icon: '📅', color: 'var(--lm-temps)', path: '/MonCalendrier?action=new-event' },
  { key: 'contact', label: ['quickAdd.contact', 'Contact'], icon: '👤', color: 'var(--lm-social)', path: '/MesContacts?action=new-contact' },
  { key: 'document', label: ['quickAdd.document', 'Document'], icon: '📄', color: '#94a3b8', path: '/documents?action=new-document' },
  { key: 'objectif', label: ['quickAdd.goal', 'Objectif'], icon: '🎯', color: '#a3e635', path: '/definir-objective?action=new-objective' },
]

const QuickAddSheet = ({ open, onClose }) => {
  const { t } = useTranslation(['layout', 'common'])
  const navigate = useNavigate()

  const go = (path) => {
    onClose()
    navigate(path)
    window.scrollTo(0, 0)
  }

  return (
    <>
      <div
        className={`lm-mask${open ? ' lm-ouvert' : ''}`}
        onClick={onClose}
      />
      <div className={`lm-sheet${open ? ' lm-ouvert' : ''}`}>
        <div className="lm-poignee" />
        <h3>{t('quickAdd.title', 'Ajout rapide')}</h3>
        <div className="lm-qgrid">
          {ACTIONS.map((a) => (
            <div key={a.key} className="lm-q" onClick={() => go(a.path)}>
              <div
                className="lm-qi"
                style={{ background: `color-mix(in srgb, ${a.color} 20%, transparent)` }}
              >
                {a.icon}
              </div>
              <div className="lm-qt">{t(a.label[0], a.label[1])}</div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default QuickAddSheet
